module.exports = __webpack_public_path__ + "assets/img/login-build3.d2f4ab4a.png";